const stringValidator = (stringToValidate, knownValue, t, componentName) => {

    if (stringToValidate == knownValue)
        return t( componentName +'_' + knownValue)

    return stringToValidate

}

const stringCamelCase = (string) => 
    string.replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
        index === 0 ? word.toLowerCase() : word.toUpperCase()
        )
        .replace(/\s+/g, '');


export { stringValidator, stringCamelCase }